import React, { Component } from 'react';
import {connect} from 'react-redux';
import * as steps from './productSearchStepConstants';
import ProductSearchFormContainer from './ProductSearchFormContainer';
import CharterTimeContainer from './CharterTimeContainer';
import OriginFilterContainer from './OriginFilterContainer';
import DestinationFilterContainer from './DestinationFilterContainer';
import OriginSearchContainer from './OriginSearchContainer';
import DestinationSearchContainer from './DestinationSearchContainer';
import DateSearchContainer from './DateSearchContainer';
import AddFlightContainer from './AddFlightContainer';

class ProductSearchStep extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    let step;
    switch(this.props.step) {
      case steps.PRODUCT_SEARCH_LOADING:
        step = <div className="product-search-loading"/>;
        break;
      case steps.PRODUCT_SEARCH_FORM:
        step = <ProductSearchFormContainer />;
        break;
      case steps.ORIGIN_SEARCH:
        step = <OriginSearchContainer />;
        break;
      case steps.DESTINATION_SEARCH:
        step = <DestinationSearchContainer />;
        break;
      case steps.DATE_SEARCH:
        step = <DateSearchContainer />;
        break;
      case steps.ADD_FLIGHT:
        step = <AddFlightContainer />;
        break;
      case steps.CHARTER_TIME_SELECTION:
        step = <CharterTimeContainer />;
        break;
      case steps.ORIGIN_FILTER:
        step = <OriginFilterContainer />;
        break;
      case steps.DESTINATION_FILTER:
        step = <DestinationFilterContainer />;
        break;
      default:
        step = <div>unknown</div>;
    }

    return step;
  }
};

function mapStateToProps(state, ownProps) {
  return {
    step: state.productSearch.step
  }
}

export default connect(mapStateToProps)(ProductSearchStep)